import { useState } from "react";
import "./sass/reviewModal.scss";
import { Form, Input, FormFeedback, Spinner, Row, Col } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createNewReview } from "../slices/reviews/thunk";
import { useProfile } from "./Hooks/UserHooks";
const ReviewModal = ({ isOpen, onClose,businessdetail }) => {
  const [rating, setRating] = useState(0);
  const { userProfile, loading, token } = useProfile();
  const [reviewLoading, setReviewLoading] = useState(false);
  const dispatch = useDispatch();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: "",
      description: "",
      rating: 0,
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Please Enter Title"),
      description: Yup.string().required("Please Select Category"),
    }),
    onSubmit: async (values) => {
      // console.log(values);
      try {
        setReviewLoading(true);

        const data = {
          title: values["title"],
          description: values["description"],
          rating: rating,
          businessId: businessdetail._id
        };

        let res = await dispatch(createNewReview(data));
        if (res?.payload?.status) {
          validation.resetForm();
          onClose();
        }
      } catch (error) {
        console.log(error);
      } finally {
        setReviewLoading(false);
      }
    },
  });

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
        className="modal-content"
        action="#"
      >
        <button className="close-btn" onClick={onClose}>
          &times;
        </button>
        <h2>Write a Review</h2>
        <label>Rating</label>
        <div className="rating-bar">
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={rating >= star ? "star filled" : "star"}
              onClick={() => setRating(star)}
            >
              ★
            </span>
          ))}
        </div>

        <label>Review Title</label>

        <Input
          type="text"
          className="form-control"
          id="title"
          placeholder="Give your review a title"
          name="title"
          value={validation.values.title || ""}
          onBlur={validation.handleBlur}
          onChange={validation.handleChange}
          invalid={
            validation.errors.title && validation.touched.title ? true : false
          }
        />
        {validation.errors.title && validation.touched.title ? (
          <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
        ) : null}

        <label>Description</label>

        <Input
          type="textarea"
          className="form-control"
          id="description"
          placeholder="Share your experience"
          name="description"
          value={validation.values.description || ""}
          onBlur={validation.handleBlur}
          onChange={validation.handleChange}
          invalid={
            validation.errors.description && validation.touched.description
              ? true
              : false
          }
        />

        <div className="review_btn">
          <button
            type="submit"
            className="btn btn-success"
            disabled={!userProfile || reviewLoading}
          >
            {reviewLoading ? <Spinner size="sm" className="me-2" /> : null}
            {userProfile ? "Submit Review" : "Login to submit review"}
          </button>
        </div>
      </Form>
    </div>
  );
};

export default ReviewModal;
